import { isString } from 'mathjs';
import Action from '../../classes/Action';
import AssetsManager from '../../classes/AssetsManager';
import AssetUtility from '../../classes/AssetUtility';
import Scenario from '../../classes/scenarioElements/Scenario';
import store, { StoreActions } from '../../state/store';

export default class ReplaceUITemplate extends Action
{
	constructor(oldAssetId: string, newAssetId: string)
	{
		const oldAssetName = AssetUtility.getAssetName(oldAssetId);
		const newAssetName = AssetUtility.getAssetName(newAssetId);
		const actionName = "Replaced " + oldAssetName + " References With " + newAssetName;
		super([oldAssetId, newAssetId], [newAssetId, oldAssetId], actionName, [oldAssetId, newAssetId]);
	}

	do(oldAssetId: string, newAssetId: string)
	{
		const currentUiState = {...store.getState().uiModule.ui};
		const slideTemplate = { ...store.getState().uiModule.slideMaster[newAssetId], slide: newAssetId, synced: true };
		delete slideTemplate.name;
		delete slideTemplate.type;

		for(const step of Scenario.getSteps())
		{
			if(currentUiState[step.id]?.slide === oldAssetId)
			{
				// replace the ui template
				store.dispatch(StoreActions.ui.setFromCopy({ stepId: step.id, content: { ...slideTemplate } }));

				// remove old used slide
				AssetsManager.removeUsedAsset(oldAssetId);

				// set new used slide
				AssetsManager.addUsedAsset(newAssetId);
			}
		}
	}

	verify(oldAssetId: string, newAssetId: string)
	{
		if(!oldAssetId || !newAssetId) return false;
		return oldAssetId !== newAssetId && isString(oldAssetId) && isString(newAssetId);
	}
}
